var exports = {
  "kL": "x936d19a0--927cec--container",
  "yy": "x936d19a0--927cec--fullwidth",
  "hF": "x936d19a0--927cec--input",
};

module.exports = exports;
